module.exports = __webpack_public_path__ + "static/media/loading.5ea6ad7d.gif";